// export const IMG_URL = "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";

export const IMG_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/"

export const swiggyApi = "https://foodfire.onrender.com/api/restaurants?lat=21.1702401&lng=72.83106070000001&page_type=DESKTOP_WEB_LISTING"


// export const swiggyApi = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.65200&lng=77.16630"

// export const SwiggyMenuApi = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=28.65200&lng=77.16630&restaurantId="

export const SwiggyMenuApi = "https://foodfire.onrender.com/api/menu?page-type=REGULAR_MENU&complete-menu=true&lat=28.65200&lng=77.16630&restaurantId="

export const defaultLat = "21.1702401"; // Default latitude for India
export const defaultLon = "72.83106070000001"; // Default longitude for India